export const DEFAULT_READ_TIMEOUT = 1000
export const DEFAULT_WRITE_TIMEOUT = 100
export const DEFAULT_PURGE_TIMEOUT = 100
export const DEFAULT_DETECT_TIMEOUT = 100
export const DEFAULT_WRITE_LOCK_WAIT_TIMEOUT = 1000
export const DEFAULT_READ_CALIBRATION_TIMEOUT = 10000
export const DEFAULT_DEVICE_DETECTION_INTERVAL = 1000
export const DEFAULT_BLOCKING_LOOP_UNEXPECTED_ERROR_WAIT = 1000
export const DEFAULT_SYNC_READ_EXPECTED_KEY_TIMEOUT = 3000
export const DEFAULT_SERIAL_BUFFER_SIZE = 1024